import React from 'react';
import { MapContainer, TileLayer, Marker, Popup, Tooltip } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix for default markers in React-Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

// Custom marker icons based on status
const createCustomIcon = (status) => {
  const colors = {
    operational: '#22c55e',
    warning: '#f59e0b',
    planned: '#6b7280',
    offline: '#ef4444'
  };

  const color = colors[status] || colors.operational;

  return L.divIcon({
    className: 'custom-marker',
    html: `
      <div class="observatory-marker ${status}" style="background-color: ${color}">
        <div class="observatory-marker-inner"></div>
      </div>
    `,
    iconSize: [30, 30],
    iconAnchor: [15, 15],
  });
};

const ObservatoryMap = ({ observatories }) => {
  return (
    <MapContainer
      center={[20, 0]}
      zoom={2}
      style={{ height: '600px', width: '100%', borderRadius: '12px' }}
      className="observatory-map-container"
      scrollWheelZoom={false}
      doubleClickZoom={false}
      touchZoom={false}
      boxZoom={false}
      zoomControl={false}
      dragging={true}
      keyboard={false}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
      />
      
      {observatories.map((observatory) => (
        <Marker
          key={observatory.id}
          position={[observatory.coordinates.lat, observatory.coordinates.lng]}
          icon={createCustomIcon(observatory.status)}
        >
          <Popup className="custom-popup">
            <div className="popup-content">
              <h3>{observatory.name}</h3>
              <p className="location">{observatory.location}</p>
              <p className="status-badge">
                <span className={`status-indicator ${observatory.status}`}></span>
                {observatory.status.charAt(0).toUpperCase() + observatory.status.slice(1)}
              </p>
              <p className="description">{observatory.description}</p>
              <p className="telescopes">Telescopes: {observatory.telescopes}</p>
            </div>
          </Popup>
          <Tooltip direction="top" offset={[0, -10]} opacity={0.9}>
            {observatory.location}
            <br />
            <strong>{observatory.telescopes} Telescopes</strong>
          </Tooltip>
        </Marker>
      ))}
    </MapContainer>
  );
};

export default ObservatoryMap;

